export { default } from './car-info-modal';
